export default "__VITE_ASSET__BDlnKkbu__"